'use client';
import { factory, Flex, AspectRatioKeeper, PhotoOverlay, DsmColor, Image, Video, Typography, omitText, OptionalPortal, FocusTrap } from '@kohler-dsm-library/kohler-core';
import { PlayIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState, isValidElement } from 'react';
import { OverlayVideo } from '../../../../Heroes/FullBleedHeroVideo/subcomponents/OverlayVideo/OverlayVideo.mjs';
import classes from './VideoCard.module.css.mjs';

const VideoCard = factory((props, ref) => {
  const { heading, duration, video, image, className, ...rest } = props;
  const [isOverlayOpen, setIsOverlayOpen] = useState(false);
  const handleClick = () => {
    if (video) {
      setIsOverlayOpen(true);
    }
  };
  return /* @__PURE__ */ React.createElement(
    Flex,
    {
      direction: "column",
      className: clsx(classes.videoCardContainer, className, "kohler-video-card-root"),
      component: "div",
      height: "100%",
      ref,
      ...rest
    },
    /* @__PURE__ */ React.createElement(
      AspectRatioKeeper,
      {
        component: video ? "button" : "div",
        type: video ? "button" : void 0,
        aspectRatio: "1:1",
        "aria-label": video ? "open fullscreen video" : void 0,
        onClick: handleClick
      },
      /* @__PURE__ */ React.createElement(PhotoOverlay, { className: classes.videoCardOverlay, opacity: 10, direction: "tint" }, video && /* @__PURE__ */ React.createElement(PlayIcon, { color: DsmColor.ContentOnPhoto, withBoundingBox: true, size: "medium" })),
      image ? /* @__PURE__ */ React.createElement(Image, { ...image }) : /* @__PURE__ */ React.createElement(Video, { decorative: true, controls: false, ...video })
    ),
    /* @__PURE__ */ React.createElement(Flex, { direction: "column", justify: "space-between", gap: 15, className: classes.videoCardContentContainer }, heading && /* @__PURE__ */ React.createElement(Typography, { component: heading.component || "h3", ...omitText(heading), size: "h6", textColor: DsmColor.ContentSecondary }, heading.text), duration && /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: isValidElement(duration.text) ? "div" : duration.component || "p",
        ...omitText(duration),
        textColor: DsmColor.ContentSecondary,
        size: "paragraph-medium"
      },
      duration.text
    )),
    isOverlayOpen && video && /* @__PURE__ */ React.createElement(OptionalPortal, { target: ".kohler-video-slider-root" }, /* @__PURE__ */ React.createElement(FocusTrap, null, /* @__PURE__ */ React.createElement(
      OverlayVideo,
      {
        zIndex: 105,
        ...video,
        autoPlay: true,
        muted: false,
        closeCTA: {
          onClick: (e) => {
            setIsOverlayOpen(false);
            video?.onClose?.();
            video?.closeCTA?.onClick?.(e);
          }
        }
      }
    )))
  );
});

export { VideoCard };
